import * as React from 'react';
import { Paper, StyleRulesCallback, WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { List } from '@material-ui/core';
import { ListItem } from '@material-ui/core';
import { ListItemText } from '@material-ui/core';
import moment from 'moment';
import PaginationNavigation from '../../PaginationNavigation';
import { Page } from '../../../api/pageable';
import { QuestionnaireDto } from '../../../pages/questionnaire/questionnaireTypes';
import { ListItemSecondaryAction } from '@material-ui/core';
import { Button } from '@material-ui/core';
import { Edit as EditIcon } from '@material-ui/icons';
import { observer } from 'mobx-react';

interface Props {
  questionnaires: Page<QuestionnaireDto>
  handleChangePage: (event: any, page: number) => void
  onClick: (id: number, questionnaire: QuestionnaireDto) => void
  secondaryClick?: (questionnaire: QuestionnaireDto) => void
  emptyPage: JSX.Element
}

type LocalStyles = 'root' | 'emptyContainer';

const localStyles: StyleRulesCallback<LocalStyles> = theme => ({
  root: {
    textAlign: 'center',
  },
  emptyContainer: {
    padding: theme.spacing.unit * 4
  }
});

type PropsWithStyle = WithStyles<LocalStyles> & Props;

@observer
class QuestionnaireList extends React.Component<PropsWithStyle> {

  constructor(props: PropsWithStyle) {
    super(props);
  }

  public render() {
    return (
      <>
        {
          this.props.questionnaires.content.length === 0 ?
            this.props.emptyPage :
            <Paper elevation={1} className={this.props.classes.root}>
              <List>
                {this.props.questionnaires.content.map(questionnaire => (
                  <ListItem
                    key={questionnaire.id}
                    button={true}
                    onClick={
                      () => this.props.onClick(questionnaire.id, questionnaire)
                    }
                  >
                    <ListItemText
                      primary={`${questionnaire.appraisee.firstName} ${questionnaire.appraisee.lastName}`}
                      secondary={`${moment(questionnaire.startDate).format('DD.MM.YYYY')}-${moment(questionnaire.endDate).format('DD.MM.YYYY')}`}
                    />
                    {
                      this.props.secondaryClick &&
                      <ListItemSecondaryAction>
                        <Button onClick={() => this.props.secondaryClick!!(questionnaire)}>
                          <EditIcon/>
                        </Button>
                      </ListItemSecondaryAction>
                    }
                  </ListItem>
                ))}
              </List>
              <PaginationNavigation
                totalPages={this.props.questionnaires.totalPages}
                page={this.props.questionnaires.pageable.pageNumber!!}
                onChangePage={this.props.handleChangePage}/>
            </Paper>
        }
      </>
    )
  }

}

export default withStyles(localStyles)(QuestionnaireList);
